<template>
  <div
    id="identification-objective-overlay"
    v-show="hasContent"
    class="
      position-absolute
      showAboveCanvas
      p-3
      pt-4
      text-start text-white
      start--100
    "
  >
    <div class="bg-translucent-black mt-4 p-3 position-relative">
      <div class="opacity-100">
        <h2>{{ visibleHeading }}</h2>
        <h3 class="fst-italic">
          {{ visibleMessage }}
        </h3>
        <div>
          {{ zoomInstructions }}
        </div>
        <div>
          {{ takePhotoInstructions }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";

export default {
  name: "OverlayHeader",
  props: {
    heading: {
      type: String
    },
    message: {
      type: String
    }
  },
  data: function () {
    return {
      visibleHeading: "",
      visibleMessage: "",
      zoomInstructions: "Zoom: RIGHT CLICK",
      takePhotoInstructions: "Take photo: LEFT CLICK"
    };
  },
  computed: {
    // Represents the full message to be displayed
    fullMessage() {
      return this.hasContent ? `${this.heading}|${this.message}` : "";
    },
    hasContent() {
      return this.message || this.heading;
    }
  },
  watch: {
    fullMessage: function (newVal, oldVal) {
      if (!oldVal && newVal) {
        this.updateVisibleContent();
        this.animateIn();
      } else if (oldVal && newVal) {
        this.animateOutAndIn();
      }
    }
  },
  methods: {
    updateVisibleContent() {
      this.visibleHeading = this.heading;
      this.visibleMessage = this.message;
    },
    animateIn() {
      gsap.fromTo(
        "#identification-objective-overlay",
        {
          left: "-100%"
        },
        {
          left: "0%",
          duration: 1,
          ease: "back.out(1)"
        }
      );
    },
    animateOutAndIn() {
      gsap
        .timeline()
        .fromTo(
          "#identification-objective-overlay",
          {
            left: "0%",
            immediateRender: false
          },
          {
            left: "-100%",
            duration: 1,
            ease: "back.in(1)",
            onComplete: () => {
              this.updateVisibleContent();
            }
          }
        )
        .fromTo(
          "#identification-objective-overlay",
          {
            left: "-100%"
          },
          {
            left: "0%",
            duration: 1,
            ease: "back.out(1)"
          }
        );
    }
  }
};
</script>

<style scoped>
.bg-translucent-black {
  background-color: rgba(0, 0, 0, 0.7);
}
.start--100 {
  left: -100%;
}
</style>
